<template>
  <div class="app-container">
    <!-- 顶部标签页导航 -->
    <div class="tabs-container">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="order-tabs">
        <el-tab-pane label="最新购买" name="latest"></el-tab-pane>
        <!-- <el-tab-pane label="未发货" name="unshipped"></el-tab-pane>
        <el-tab-pane label="已发货" name="shipped"></el-tab-pane>
        <el-tab-pane label="已退款" name="refunded"></el-tab-pane>
        <el-tab-pane label="截单" name="cutoff"></el-tab-pane> -->
      </el-tabs>
    </div>
    
    <!-- 筛选区域 -->
    <!-- <div class="filter-section">
      <div class="filter-row">
        <div class="filter-group">
          <label class="filter-label">选择快递类型</label>
          <el-select v-model="listQuery.expressType" placeholder="选择快递类型" clearable class="filter-select">
            <el-option label="韵达快递" value="yunda"></el-option>
            <el-option label="圆通快递" value="yuantong"></el-option>
            <el-option label="申通快递" value="shentong"></el-option>
            <el-option label="中通快递" value="zhongtong"></el-option>
            <el-option label="顺丰速运" value="shunfeng"></el-option>
          </el-select>
        </div>
        
        <div class="filter-group">
          <label class="filter-label">请选择平台</label>
          <el-select v-model="listQuery.platform" placeholder="请选择平台" clearable class="filter-select">
            <el-option label="淘宝" value="taobao"></el-option>
            <el-option label="拼多多" value="pinduoduo"></el-option>
            <el-option label="京东" value="jd"></el-option>
            <el-option label="抖音" value="douyin"></el-option>
            <el-option label="1688" value="1688"></el-option>
          </el-select>
        </div>
        
        <div class="filter-group">
          <label class="filter-label">成交时间</label>
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="filter-date-picker">
          </el-date-picker>
        </div>
        
        <div class="filter-group">
          <label class="filter-label">订单编号</label>
          <el-input v-model="listQuery.orderNo" placeholder="请输入订单编号" clearable class="filter-input"></el-input>
        </div>
        
        <div class="filter-group">
          <label class="filter-label">快递单号</label>
          <el-input v-model="listQuery.expressNo" placeholder="请输入快递单号" clearable class="filter-input"></el-input>
        </div>
        
        <div class="filter-group">
          <label class="filter-label">淘宝/拼多多/京东 | 订单号</label>
          <el-input v-model="listQuery.platformOrderNo" placeholder="请输入平台订单号" clearable class="filter-input"></el-input>
        </div>
        
        <div class="filter-group">
          <label class="filter-label">批次号 | 扣费订单号</label>
          <el-input v-model="listQuery.batchNo" placeholder="请输入批次号" clearable class="filter-input"></el-input>
        </div>
        
        <div class="filter-buttons">
          <el-button type="primary" @click="handleFilter" class="query-btn">查询</el-button>
          <el-button type="primary" @click="handleExport" class="export-btn">导出订单</el-button>
        </div>
      </div>
    </div> -->
    <!-- 订单列表 -->
    <div class="order-list-section" v-loading="listLoading">
      <!-- 表头 -->
      <div class="order-table-header">
        <div class="order-header-cell" style="min-width: 300px;">商品信息</div>
        <div class="order-header-cell" style="min-width: 150px;">上家快递</div>
        <div class="order-header-cell" style="min-width: 150px;">发货信息</div>
        <div class="order-header-cell" style="min-width: 200px;">收货信息</div>
        <div class="order-header-cell" style="min-width: 100px;">费用</div>
        <div class="order-header-cell" style="min-width: 200px;">快递单号</div>
        <div class="order-header-cell" style="min-width: 200px;">操作</div>
      </div>

      <!-- 订单列表 -->
      <div 
        v-for="(order, index) in list" 
        :key="index" 
        class="order-item"
      >
        <!-- 订单基本信息行 -->
        <div class="order-basic-row">
          <div class="order-cell order-basic-info-cell">
            <div class="order-basic-info">
              <div class="order-number" v-if="order.orderNo">订单编号: {{ order.orderNo }}</div>
              <div class="create-time">创建时间: {{ order.created_at }}</div>
              <div class="platform-order">
                <img :src="order.platformIcon" v-if="order.platformIcon" class="platform-icon-img" alt="平台图标">
                {{ order.platformOrderNo }}
              </div>
            </div>
          </div>
        </div>

        <!-- 订单详情行 -->
        <div class="order-detail-row">
          <div class="order-cell" style="min-width: 300px;">
            <div class="product-detail">
              <img :src="STATIC_URL + 'storage/' + order.pic" v-if="order.pic" class="product-image" alt="商品图片">
              <div class="product-text">
                <div class="product-name">{{ order.goodsName }}</div>
                <div class="product-weight" v-if="order.weight">重量: {{ order.weight }}</div>
              </div>
            </div>
          </div>
          
          <div class="order-cell" style="min-width: 150px;">
            <div class="shipping-info">
              <span v-if="order.express_no">1段：{{ order.express_no }} ({{ order.express_pro }}) </span>
              <span v-if="order.two_express_no">2段：{{ order.two_express_no }} </span>
            </div>
          </div>
          
          <div class="order-cell" style="min-width: 150px;">
            <div class="shipping-info">
              <div class="contact-info">{{ order.send_name }} {{ order.send_phone }}</div>
              <div class="address">{{ order.send_addr }}</div>
            </div>
          </div>
          
          <div class="order-cell" style="min-width: 200px;">
            <div class="receive-info">
              <div class="platform-order-link">{{ order.platformOrderNo }}</div>
              <div class="receiver-info">{{ order.receiving_name }} {{ order.receiving_phone }}</div>
              <div class="receive-address">{{ order.receiving_addr }}</div>
            </div>
          </div>
          
          <div class="order-cell" style="min-width: 100px;">
            <span class="cost">¥ {{ order.change_money }}</span>
          </div>
          
          <div class="order-cell" style="min-width: 200px;">
            <div class="express-number">
              <div class="express-company">{{ order.send_express_pro }}</div>
              <div class="express-no">{{ order.send_express_no }}</div>
            </div>
          </div>
          
          <div class="order-cell" style="min-width: 200px;">
            <!-- 操作按钮可以在这里添加 -->
          </div>
        </div>
      </div>
        <!-- 分页控件 -->
        <div class="pagination-container" v-if="total > 0">
          <div class="pagination-info">
            <span>共 {{ total }} 条记录</span>
          </div>
          <div class="custom-pagination">
            <button 
              class="pagination-btn" 
              :disabled="listQuery.page === 1"
              @click="handlePageChange(listQuery.page - 1)"
            >
              上一页
            </button>
            <div class="pagination-pages">
              <button
                v-for="page in visiblePages"
                :key="page"
                class="pagination-page-btn"
                :class="{ 'active': page === listQuery.page, 'disabled': page === '...' }"
                :disabled="page === '...'"
                @click="page !== '...' && handlePageChange(page)"
              >
                {{ page }}
              </button>
            </div>
            <button 
              class="pagination-btn" 
              :disabled="listQuery.page >= totalPages"
              @click="handlePageChange(listQuery.page + 1)"
            >
              下一页
            </button>
          </div>
        </div>
      </div>

    <!-- 对话框 -->
    <el-dialog
          title="推送取件码"
          :visible.sync="pickCode_dialogFormVisible"
          style="width: 60%; margin-left: 20%"
        >
          <el-form
            ref="pc_dataForm"
            :rules="pickCodeRules"
            :model="pickCodeTemp"
            label-width="120px"
            style="width: 90%"
          >
            <el-form-item label="同步物流单号" prop="trackingNo">
              <el-input
                v-model="pickCodeTemp.trackingNo"
              />
            </el-form-item>

            <el-form-item label="取件码" prop="pickCode"
              ><el-input v-model="pickCodeTemp.pickCode"
            /></el-form-item>
            <el-form-item label="代收点" prop="address"
              ><el-input v-model="pickCodeTemp.address"
            /></el-form-item>
            <el-form-item label="代收点地址" prop="expressAddress"
              ><el-input v-model="pickCodeTemp.expressAddress"
            /></el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="pickCode_dialogFormVisible = false"> 取消 </el-button>
            <el-button type="primary" @click="pushPickCode()"> 提交 </el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="推送二段物流"
          :visible.sync="pushSenc_dialogFormVisible"
          style="width: 70%; margin-left: 14%"
        >
          <el-form
            ref="pushSenc_dataForm"
            :rules="pushSencRules"
            :model="pushSencTemp"
            label-width="150px"
            style="width: 90%"
          >
            <el-form-item label="同步物流单号" prop="trackingNo">
              <el-input
                v-model="pushSencTemp.trackingNo"
              />
            </el-form-item>

            <el-form-item label="二段物流公司名称" prop="shipperCode"
              ><el-select
                v-model="pushSencTemp.shipperCode"
                class="filter-item"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in kuaidiList"
                  :key="index"
                  :label="item"
                  :value="item"
                  >{{ item }}</el-option
                >
              </el-select>
              </el-form-item>
            <el-form-item label="二段物流单号" prop="expressNo"
              ><el-input v-model="pushSencTemp.expressNo"
            /></el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="pushSenc_dialogFormVisible = false"> 取消 </el-button>
            <el-button type="primary" @click="secondStageLogisticsUpdate()"> 提交 </el-button>
          </div>
        </el-dialog>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import axios from "axios";
import Cookies from "js-cookie";
import waves from "@/directive/waves"; // waves directive
import moment from "moment";
import {STATIC_URL} from '../../../../config/constants'

export default {
  name: "orders",
  components: {
    "el-date-picker": DatePicker,
  },
  directives: { waves },
  data() {
    return {
      STATIC_URL,
      isLogin: false,
      activeTab: 'latest',
      cangList: [],
      list: [],
      total: 0,
      listLoading: false,
      dateRange: [],
      // listQuery: {
      //   type: 2,
      //   page: 1,
      //   perPage: 20,
      //   start_time: "",
      //   end_time: "",
      //   remarks: "",
      //   time: "detail",
      //   system_id: "",
      // },
      listQuery: {
        page: 1,
        pageNum: 20,
        expressType: '',
        platform: '',
        orderNo: '',
        expressNo: '',
        platformOrderNo: '',
        batchNo: '',
        startDate: '',
        endDate: '',
        tabType: 'latest'
      },
      startDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        new Date().getDate()
      ),
      endDate:  new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(), 23, 59, 59),
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime(); // 选则的时间
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.startDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      pickCodeTemp: {
        trackingNo: "",
        pickCode: "",
        address: "",
        expressAddress: "",
      },
      pickCodeRules: {
        trackingNo: [{ required: true, message: "同步物流单号不能为空", trigger: "blur" }],
        pickCode: [{ required: true, message: "取件码不能为空", trigger: "blur" }],
        address: [{ required: true, message: "代收点不能为空", trigger: "blur" }],
        expressAddress: [{ required: true, message: "代收点地址不能为空", trigger: "blur" }],
      },
      pickCode_dialogFormVisible: false,

      pushSencTemp: {
        trackingNo: "",
        shipperCode: "",
        expressNo: "",
      },
      pushSencRules: {
        trackingNo: [{ required: true, message: "同步物流单号不能为空", trigger: "blur" }],
        shipperCode: [{ required: true, message: "二段物流公司名称不能为空", trigger: "blur" }],
        expressNo: [{ required: true, message: "二段物流单号不能为空", trigger: "blur" }],
      },
      pushSenc_dialogFormVisible: false,
      kuaidiList: [
        "申通快递",
        "圆通速递",
        "韵达速递",
        "邮政快递包裹",
        "EMS",
        "顺丰速运",
        "京东快递",
        "优速快递",
        "德邦快递",
        "极兔速递",
        "菜鸟速递",
        "菜鸟橙运",
        "丹鸟物流",
        "宅急送",
        "丰网速运",
        "中通快递",
        "韵达快递",
        "圆通快递",
        "京东配送",
        "邮政EMS",
        "邮政电商标快",
        "安能快递",
        "安能快运/物流",
        "安捷快递",
        "安迅物流",
        "安邮美国",
        "亚马逊物流",
        "澳门邮政",
        "澳多多",
        "澳邮专线",
        "安鲜达",
        "安敏物流",
        "安得物流",
        "澳德物流",
        "转运四方",
        "A2U速递",
        "AAE全球专递",
        "明大快递",
        "德国雄鹰速递",
        "安达信",
        "全程快递",
        "德方物流",
        "卡邦配送",
        "加拿大民航快递",
        "捷记方舟",
        "AlfaTrex",
        "无忧物流",
        "ALLIED",
        "心怡物流",
        "亚马逊中国订单",
        "amazon-国际订单",
        "安家同城快运",
        "青岛安捷快递",
        "Anteraja",
        "荷属安的列斯荷兰邮政",
        "安信达",
        "澳速物流",
        "Aramex",
        "ARC",
        "澳达国际物流",
        "澳货通",
        "奥地利邮政",
        "AUV国际快递",
        "澳新物流",
        "安鹿物流",
        "八达通",
        "百腾物流",
        "奔腾物流",
        "八方安运",
        "百世国际",
        "百世云配",
        "宝通快递",
        "8+1物流",
        "报通快递",
        "BDC快递",
        "北京丰越供应链",
        "飛斯特",
        "败欧洲",
        "百福东方物流",
        "上海缤纷物流",
        "彪记快递",
        "青云物流",
        "鑫锐达",
        "远通盛源",
        "佰乐捷通",
        "比利时邮政",
        "蓝天国际航空快递",
        "巴伦支快递",
        "标杆物流",
        "笨鸟国际",
        "堡昕德速递",
        "速方(Sufast)",
        "百千诚物流",
        "宏桥国际物流",
        "百事亨通速递",
        "邦泰快运",
        "展勤快递",
        "百世快运",
        "帮帮发转运",
        "百城通物流",
        "百米快运",
        "北京渡石",
        "重庆博卡联物流",
        "春风物流",
        "菜鸟橙运",
        "广东诚通物流",
        "传喜物流",
        "窝里快购",
        "城市100",
        "CEVA物流",
        "城际快递",
        "长通物流",
        "CNPEX中邮快递",
        "COE东方快递",
        "长沙创一",
        "成都善途速运",
        "加拿大邮政",
        "能装能送",
        "卢森堡航空",
        "广州信邦",
        "钏博物流",
        "中集冷云",
        "中迅三方",
        "捷祥物流",
        "鑫宸物流",
        "银雁专送",
        "河北橙配",
        "城通物流",
        "荣通国际",
        "SQK国际速递",
        "嘉荣物流",
        "CHS中环国际快递",
        "诚和通",
        "中国香港骏辉物流",
        "城市映急",
        "大韩通运",
        "城晓国际快递",
        "出口易",
        "澳通华人物流",
        "群航国际物流",
        "CNAIR",
        "中澳速递",
        "马珂博逻",
        "速舟物流",
        "中国翼",
        "华中快递",
        "重庆星程快递",
        "环旅快运",
        "新时速物流",
        "村通快递",
        "小飞侠速递",
        "云南诚中物流",
        "联合运通",
        "CBO钏博物流",
        "佳吉快运",
        "畅顺通达",
        "D速物流",
        "到了港",
        "大田物流",
        "大众佐川急便",
        "叮当同城",
        "多道物流",
        "深圳德创物流",
        "德豪驿",
        "德坤物流",
        "澳行快递",
        "东风全球速递",
        "达发物流",
        "递五方云仓",
        "云南滇驿物流",
        "递达速运",
        "叮咚澳洲转运",
        "叮咚快递",
        "递四方澳洲",
        "递四方美国",
        "吉布提",
        "东瀚物流",
        "DPD",
        "老司机国际快递",
        "德淘邦",
        "德邦快运/德邦物流",
        "大马鹿",
        "东方汇",
        "递易家",
        "E特快",
        "东方航空物流",
        "邮速达",
        "东西E全运",
        "易联通达",
        "澳州顺风快递",
        "EMS包裹",
        "EMS物流",
        "贰仟家物流",
        "europeanecom",
        "可可树美中速运",
        "7号速递",
        "易转运",
        "EMS国内",
        "EWE",
        "E通速递",
        "飞康达",
        "凡宇货的",
        "速派快递",
        "丰程物流",
        "FEDEX联邦（国内）",
        "飞快达",
        "凤凰快递",
        "奉天物流",
        "四方格",
        "全速快递",
        "富吉速运",
        "法翔速运",
        "飞豹快递",
        "泛球物流",
        "丰巢",
        "飞狐快递",
        "复融供应链",
        "飞远配送",
        "凡宇速递",
        "丰通快运",
        "冠达",
        "广东邮政",
        "共速达",
        "快捷快物流",
        "全网物流",
        "容智快运",
        "国际邮政包裹",
        "时安达速递",
        "万通快递",
        "冠泰",
        "GTS快递（广通速递）",
        "广东通路",
        "永邦快递",
        "全联速运",
        "天天快物流",
        "广州安能聚创物流",
        "贵州星程快递",
        "广通",
        "冠达快递",
        "广通速递",
        "高铁快运",
        "迦递快递",
        "港快速递",
        "高铁速递",
        "广东易代收",
        "黑狗冷链",
        "弘家物流",
        "恒路物流",
        "天地华宇",
        "鸿桥供应链",
        "海派通物流公司",
        "华强物流",
        "华夏龙物流",
        "河北建华",
        "汇达快递",
        "汇丰物流",
        "华航快递",
        "华翰物流",
        "海盟速递",
        "华企快运",
        "华兴物流",
        "昊盛物流",
        "鸿泰物流",
        "合肥汇文",
        "辉隆物流",
        "宏利德物流",
        "海红网送",
        "航宇快递",
        "豪翔物流",
        "开心快递",
        "宏递快运",
        "黑猫速运",
        "合心速递",
        "环国运物流",
        "华瀚快递",
        "海欣斯快递",
        "Hi淘易快递",
        "猴急送物流",
        "飞豹速递",
        "香港邮政",
        "互联快运",
        "共联配",
        "海联快递",
        "顺时达物流",
        "中强物流",
        "如家国际快递",
        "居家通",
        "洪都拉斯",
        "宏捷国际物流",
        "宏品物流",
        "海硕高铁速递",
        "户尚冷链物流",
        "恒通快递",
        "环东物流",
        "华夏货运",
        "汇峰物流",
        "汇霖大货网",
        "货拉拉物流",
        "户通物流",
        "鸿远物流",
        "上海昊宏国际货物",
        "恒宇运通",
        "华企快递",
        "韩润物流",
        "货运皇物流",
        "好来运快递",
        "皇家物流",
        "海信物流",
        "汇森速运",
        "徽托邦物流",
        "爱拜物流",
        "泛太优达",
        "无限速递",
        "捷安达",
        "京广速递",
        "九曳供应链",
        "急先达",
        "晋越快递",
        "佳成国际",
        "嘉诚速达",
        "急递",
        "捷仕",
        "佳辰国际速递",
        "佳家通货运",
        "加佳物流",
        "佳吉快递",
        "嘉贤物流",
        "捷邦物流",
        "极光转运",
        "金岸物流",
        "锦程物流",
        "近端",
        "景顺物流",
        "劲通快递",
        "冀速物流",
        "久久物流",
        "佳捷翔物流",
        "极速达",
        "绝配国际速递",
        "金润荷役物流",
        "骏绅物流",
        "时达通",
        "聚鼎物流",
        "聚盟共建",
        "骏丰国际速递",
        "聚物物流",
        "捷特快递",
        "精英速运",
        "加运美",
        "景光物流",
        "佳怡物流",
        "京东快运",
        "金大物流",
        "跨越速运",
        "快服务",
        "快速递物流",
        "康力物流",
        "快淘快递",
        "考拉国际速递",
        "科捷物流",
        "嘉里大荣物流",
        "启邦国际物流",
        "科紫物流",
        "快航飞递",
        "考拉速递",
        "韩国邮政韩文",
        "淘韩国际快递",
        "四川快优达速递",
        "凯信达",
        "快优达速递",
        "快8速运",
        "龙邦快递",
        "蓝弧快递",
        "拉火速运",
        "蓝镖快递",
        "立白宝凯物流",
        "两点之间",
        "楽道物流",
        "乐递供应链",
        "云豹国际货运",
        "美联快递",
        "联合速递",
        "联合快递",
        "联邦快递-英文",
        "成都立即送",
        "领送送",
        "小熊物流",
        "新易泰",
        "龙邦速递",
        "加拿大龙行速运",
        "长风物流",
        "6LSEXPRESS",
        "乐天速递",
        "联通快递",
        "陆本速递",
        "论道国际物流",
        "绿卡城配",
        "联运通物流",
        "乐捷递",
        "立即送",
        "联昊通速递",
        "民邦快递",
        "民航快递",
        "美快",
        "门对门快递",
        "今枫国际快运",
        "迈达物流",
        "美泰物流",
        "美西快递",
        "魔速达",
        "闽盛快递",
        "密尔克卫",
        "迈隆递运",
        "明亮物流",
        "美乐维冷链物流",
        "南方传媒物流",
        "星云速递",
        "尼尔物流",
        "速尔哪吒",
        "云链航空",
        "南天物流",
        "腾达速递",
        "诺尔国际物流",
        "偌亚奥国际快递",
        "新西兰中通",
        "能达速递",
        "ONTRAC",
        "平安达腾飞快递",
        "泛捷快递",
        "品骏快递",
        "陪行物流",
        "诚一物流",
        "英国邮政大包EMS",
        "急顺通",
        "普畅物流",
        "全球速递",
        "派尔快递",
        "配思货运",
        "鹏程快递",
        "品信快递",
        "龙行天下",
        "PostElbe",
        "荷兰邮政-中国件",
        "PCAExpress",
        "皮牙子快递",
        "全晨快递",
        "全日通快递",
        "快客快递",
        "全信通",
        "秦邦快运",
        "雪域快递",
        "雪域易购",
        "全川摩运",
        "千里速递",
        "秦岭智能速运",
        "全球邮政",
        "全际通",
        "全速通",
        "全通快运",
        "七曜中邮",
        "如风达",
        "荣庆物流",
        "日日顺物流",
        "日昱物流",
        "人人转运",
        "睿和泰速运",
        "锐界同城",
        "日日顺快线",
        "日日顺智慧物联",
        "瑞丰速递",
        "赛澳递",
        "苏宁物流",
        "圣安物流",
        "上大物流",
        "盛丰物流",
        "速通物流",
        "速腾快递",
        "速必达物流",
        "速递e站",
        "速呈宅配",
        "速尔快递",
        "山东海红",
        "盛辉物流",
        "穗佳物流",
        "三态速递",
        "山西红马甲",
        "世运快递",
        "盛通快递",
        "郑州速捷",
        "赛澳递for买卖宝",
        "叁虎物流",
        "中加国际快递",
        "四川星程快递",
        "药淘齐物流",
        "速达速递",
        "尚橙物流",
        "上海快通",
        "山西建华",
        "捎客物流",
        "杰响物流",
        "闪货极速达",
        "上海林道货运",
        "同城快寄",
        "顺丰-繁体",
        "顺丰快运",
        "顺丰冷链",
        "顺捷达",
        "顺捷丰达",
        "顺士达速运",
        "签收快递",
        "中外运空运",
        "中外运速递-中文",
        "易普递",
        "四季安物流",
        "行必达",
        "申必达",
        "速速达",
        "星速递",
        "星运快递",
        "美国申通",
        "申通新西兰",
        "智德物流",
        "速豹",
        "特急便物流",
        "速风快递",
        "速品快递",
        "苏里南",
        "瑞士邮政",
        "瑞典邮政",
        "三象速递",
        "红马甲物流",
        "沈阳佳惠尔",
        "深圳DPEX",
        "世华通物流",
        "深圳邮政",
        "顺心捷达",
        "商桥物流",
        "佳旺达物流",
        "台湾邮政",
        "泰联物流",
        "唐山申通",
        "特急送",
        "通和天下",
        "通用物流",
        "泰进物流",
        "特宝专送",
        "天翔快递",
        "万家通快递",
        "泰实货运",
        "老扬州物流",
        "明通国际快递",
        "通达兴物流",
        "运联科技",
        "铁中快运",
        "华宇物流",
        "天玺物流",
        "泰捷达物流",
        "优联吉运",
        "UTAO优到",
        "全一快递",
        "万家康",
        "万家物流",
        "中粮我买网",
        "万象物流",
        "微特派",
        "宁夏万家通",
        "万达美",
        "威盛快递",
        "凡仕特物流",
        "沃埃家",
        "伍圆速递",
        "51跨境通",
        "温通物流",
        "武汉晓毕物流",
        "迅驰物流",
        "信丰物流",
        "希优特",
        "祥龙运通",
        "新杰物流",
        "鑫梦成",
        "新宁物流",
        "鑫通宝物流",
        "国晶物流",
        "祥龙运通物流",
        "翔腾物流",
        "喜来快递",
        "迅选物流",
        "行云物流",
        "鑫远东速运",
        "西邮寄",
        "晓毕物流",
        "永昌物流",
        "宇达物流",
        "源安达快递",
        "远成物流",
        "远成快运",
        "义达国际物流",
        "药康达快递",
        "原飞航物流",
        "耀奇物流",
        "亿领速运",
        "亿顺航",
        "易通达",
        "鼹鼠快送",
        "运通快运",
        "亚风快递",
        "运通快递",
        "亿翔快递",
        "运东西网",
        "壹米滴答",
        "一站通速运",
        "驭丰速运",
        "余氏东风",
        "耀飞快递",
        "韵达快运",
        "云路",
        "邮必佳",
        "越丰物流",
        "顺捷丰达/银捷速递",
        "英脉物流",
        "音素快运",
        "一统飞鸿",
        "亚马逊中国",
        "一辉物流",
        "易达丰国际速递",
        "易航物流",
        "英超物流",
        "一起送",
        "一正达速运",
        "武汉优进汇",
        "洋口岸",
        "黑猫同城送",
        "永邦国际物流",
        "永昌物流",
        "邮必佳快递",
        "邮畅快运",
        "邮来速递",
        "壹品速递",
        "远盾物流",
        "圆通快运",
        "元智捷诚",
        "宇捷通",
        "美国云达",
        "韵丰物流",
        "运通速运",
        "邮驿帮速运",
        "西安运逸快递",
        "远洋国际快递",
        "鹰运",
        "圆通国际",
        "宇鑫物流",
        "包裹/平邮/挂号信",
        "一智通",
        "一路发物流",
        "云聚物流",
        "宇佳物流",
        "众邮快递",
        "中铁快运",
        "中天万运",
        "中外运速递",
        "澳转运",
        "八达网",
        "贝易购",
        "赤兔马转运",
        "浩运物流",
        "逐电快运",
        "卓实快运",
        "CUL中美速递",
        "ETD",
        "风驰快递",
        "风雷速递",
        "皓晨优递",
        "海带宝",
        "汇丰美中速递",
        "豪杰速递",
        "华美快递",
        "360hitao转运",
        "海淘村",
        "365海淘客",
        "华通快运",
        "海星桥快递",
        "华兴速运",
        "LogisticsY",
        "领跑者快递",
        "量子物流",
        "明邦转运",
        "168美中快递",
        "欧e捷",
        "欧洲疯",
        "欧洲GO",
        "全美通",
        "直德邮",
        "三三国际物流",
        "招金精炼",
        "鑫正一快递",
        "中宏物流",
        "中环转运",
        "中速快件",
        "中铁飞豹",
        "忠信达",
        "众派速递",
        "创运物流",
        "振捷国际货运",
        "苏通快运",
        "三真驿道",
        "中粮鲜到家物流",
        "中通智运",
        "中融泰隆",
        "准实快运",
        "明辉物流",
        "中途速递",
        "纵通速运",
        "中网物流",
        "爱购转运",
        "澳世速递",
        "斑马物流",
        "百通物流",
        "策马速递",
        "宜送转运",
        "飞碟快递",
        "飞鸽快递",
        "风行快递",
        "皓晨快递",
        "君安快递",
        "骏达快递",
        "久禾快运",
        "金海淘",
        "龙象快递",
        "美速通",
        "QQ-EX",
        "瑞天快递",
        "四方转运",
        "上腾快递",
        "滕牛快递",
        "唐三藏转运",
        "同心快递",
        "天翼快递",
        "星辰快递",
        "先锋快递",
        "云骑快递",
        "运淘美国",
        "中远快运",
        "增速海淘",
        "郑州建华",
        "SCS国际物流",
        "SOHO苏豪国际",
        "Sonic-Ex速递",
        "通诚美中快递",
        "TrakPak",
        "天天海淘",
        "天泽快递",
        "迅达快递",
        "信达速运",
        "新干线快递",
        "信捷转运",
        "优购快递",
        "友家速递(UCS)",
        "云畔网",
        "易送网",
        "中运全速",
        "中邮物流",
        "汇强快递",
        "众通快递",
        "中通快运",
        "中通冷链",
        "中骅物流",
        "中铁物流",
        "智汇鸟",
        "中原快运",
        "正鑫小飞侠",
      ],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.listQuery.pageNum) || 1
    },
    visiblePages() {
      const current = this.listQuery.page
      const total = this.totalPages
      const pages = []
      
      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i)
        }
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i)
          }
          pages.push('...')
          pages.push(total)
        } else if (current >= total - 3) {
          pages.push(1)
          pages.push('...')
          for (let i = total - 4; i <= total; i++) {
            pages.push(i)
          }
        } else {
          pages.push(1)
          pages.push('...')
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i)
          }
          pages.push('...')
          pages.push(total)
        }
      }
      
      return pages
    }
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
        });
      return;
    } else {
      this.isLogin = true;
      // const systemId = Cookies.get("view_system_id");
      // this.listQuery.system_id = systemId;
      this.getCangList();
      this.getList();
    }
  },
  methods: {
    handlePageChange(page) {
      if (page < 1 || page > this.totalPages || page === this.listQuery.page) {
        return
      }

      this.listQuery.page = page
      
      this.getList();
    },
    getCangList() {
      // const userToken = Cookies.get("view_userToken");
      // if (userToken == undefined) {
      //   // 重新导航到登录页面
      //   localStorage.clear();
      //   this.$root.removeCookies();
      //   this.$router.push({ path: "/login" });
      //   return;
      // }

      // this.cangList = [];
      // //this.total = 0;
      // const url = this.$root.commonPreUrl + "/admin/cangList";
      // const res = axios.get(url, {
      //   headers: {
      //     Authorization: "Bearer " + userToken,
      //   },
      //   params: {page:1, perPage:1000},
      // });
      // res
      //   .then((response) => {
      //     const resd = response.data;
      //     if (resd.code == "0") {
      //       this.cangList = resd.data.data;
      //     }
      //     setTimeout(() => {
      //       return;
      //     }, 1.5 * 1000);
      //   })
      //   .catch((error) => {
      //     console.error("初始请求失败:", error);
      //     // 处理错误，比如设置data为默认值或错误状态
      //     return;
      //   });
      // // Just to simulate the time of the request
      // setTimeout(() => {
      // }, 1.5 * 1000);
    },
    getList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
        return;
      }

      this.list = [];
      this.total = 0;
      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/getOrderListRecord";
      
      // 确保使用最新的参数
      const params = { ...this.listQuery };
      
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: params,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            let orderList = resd.data.data;
            orderList.forEach((item) => {
              let remarks = item.remarks;
              const start = remarks.indexOf('订单号为：');
              if(start != -1) {
                item.orderNo = remarks.substring(start+5);
              }

              const start1 = remarks.indexOf('物流单号:');
              const end1 = remarks.indexOf(',订单号为');
              item.wuliuNo = remarks.slice(start1+5, end1);
              const goodsStart = remarks.indexOf(',物流单号');
              if(goodsStart != -1) {
                item.goodsName = remarks.slice(0, goodsStart);
              } else {
                item.goodsName = remarks;
              }
              // item.send_info = item.send_name + ',' + item.send_phone + ',' + item.send_addr;
            });
            this.list = orderList;
            this.total = resd.data.total;
            this.listLoading = false;
          }
        })
        .catch((error) => {
          alert("网络异常，请稍后刷新重试！");
          // 处理错误，比如设置data为默认值或错误状态
          this.listLoading = false;
          return;
        });
        setTimeout(() => {
          this.listLoading = false;
      }, 1.5 * 1000);
    },
    handleFilter() {
      this.listQuery.page = 1;
      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.startDate = this.dateRange[0];
        this.listQuery.endDate = this.dateRange[1];
      }
      this.getList();
    },
    handleTabClick(tab) {
      this.listQuery.tabType = tab.name;
      this.listQuery.page = 1;
      this.getList();
    },
    handleExport() {
      // 导出订单功能
      this.$message.success('导出功能开发中...');
    },
    resetPickCodeTemp(){
      this.pickCodeTemp =  {
        trackingNo: "",
        pickCode: "",
        address: "",
        expressAddress: "",
      }
    },
    handle_pushPickCode(row){
      this.resetPickCodeTemp();
      this.$nextTick(() => {
        this.$refs["pc_dataForm"].clearValidate();
      });
      this.pickCodeTemp.trackingNo = row.wuliuNo;
      this.pickCode_dialogFormVisible = true;
    },
    pushPickCode() {
      this.$refs["dataForm"].validate((valid) => {
      const url =
        this.$root.ycApiUrl + "api/express/push-pick-code?trackingNo=" +
        this.pickCodeTemp.trackingNo +
        "&pickCode=" +
        this.pickCodeTemp.pickCode +
        "&address=" +
        this.pickCodeTemp.address +
        "&expressAddress=" +
        this.pickCodeTemp.expressAddress;
      const res = axios.post(url);
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.$notify({
              title: "成功",
              message: "取件码推送成功",
              type: "success",
              duration: 2000,
            });
            this.pickCode_dialogFormVisible = false;
          } else {
            this.$confirm(resd.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {})
              .catch(() => {});
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          // 处理错误，比如设置data为默认值或错误状态
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
      });
    },
    
    resetPushSencTemp(){
      this.pushSencTemp =  {
        trackingNo: "",
        shipperCode: "",
        expressNo: "",
      }
    },
    handle_twoStageLogisticsUpdate(row){
      this.resetPushSencTemp();
      this.$nextTick(() => {
        this.$refs["pushSenc_dataForm"].clearValidate();
      });
      this.pushSencTemp.trackingNo = row.wuliuNo;
      this.pushSenc_dialogFormVisible = true;
    },
    twoStageLogisticsUpdate() {
      this.$refs["dataForm"].validate((valid) => {
      const url =
        this.$root.ycApiUrl + "api/express/two-stage-logistics-update?trackingNo=" +
        this.trackingNo +
        "&shipperCode=" +
        this.shipperCode +
        "&expressNo=" +
        this.expressNo;
      const res = axios.post(url);
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
             this.$notify({
              title: "成功",
              message: "二段物流推送成功",
              type: "success",
              duration: 2000,
            });
            this.pushSenc_dialogFormVisible = false;
          } else {
            this.$confirm(resd.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {})
              .catch(() => {});
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          // 处理错误，比如设置data为默认值或错误状态
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
      });
    },
  },
};
</script>

<style>
@import "vue2-datepicker/index.css";

/* 页面整体样式 */
.app-container {
  background: #fff;
  min-height: 100vh;
}

/* 标签页样式 */
.tabs-container {
  margin-bottom: 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
}

.order-tabs .el-tabs__header {
  margin: 0;
  border-bottom: none;
}

/* .order-tabs .el-tabs__nav-wrap {
  padding: 0 20px;
} */

.order-tabs .el-tabs__item {
  font-size: 14px;
  padding: 0 20px;
  height: 50px;
  line-height: 50px;
  color: #606266;
  border-bottom: 2px solid transparent;
}

.order-tabs .el-tabs__item.is-active {
  color: #409EFF;
  font-weight: bold;
  border-bottom-color: #409EFF;
}

/* 筛选区域样式 */
.filter-section {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.filter-row {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
  row-gap: 16px;
}

.filter-group {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  min-width: 0;
}

.filter-label {
  margin-right: 8px;
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
  flex-shrink: 0;
}

.filter-select,
.filter-input {
  width: 180px;
  flex-shrink: 0;
}

.filter-date-picker {
  width: 360px;
  flex-shrink: 0;
}

.filter-buttons {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.query-btn,
.export-btn {
  background-color: #409EFF;
  border-color: #409EFF;
  padding: 8px 16px;
  font-size: 14px;
}

/* 响应式布局 */
@media (max-width: 1600px) {
  .filter-select,
  .filter-input {
    width: 160px;
  }
  
  .filter-date-picker {
    width: 320px;
  }
}

@media (max-width: 1400px) {
  .filter-select,
  .filter-input {
    width: 150px;
  }
  
  .filter-date-picker {
    width: 300px;
  }
}

@media (max-width: 1200px) {
  .filter-select,
  .filter-input {
    width: 140px;
  }
  
  .filter-date-picker {
    width: 280px;
  }
  
  .filter-buttons {
    margin-left: 0;
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .filter-section {
    padding: 15px;
  }
  
  .filter-row {
    gap: 12px;
    row-gap: 12px;
  }
  
  .filter-group {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .filter-label {
    margin-right: 0;
    margin-bottom: 6px;
  }
  
  .filter-select,
  .filter-input,
  .filter-date-picker {
    width: 100%;
  }
  
  .filter-buttons {
    width: 100%;
    justify-content: flex-start;
    margin-top: 8px;
  }
  
  .query-btn,
  .export-btn {
    flex: 1;
  }
}

/* 订单列表样式 */
.order-list-section {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
}

/* 表头样式 */
.order-table-header {
  display: grid;
  grid-template-columns: minmax(300px, 1fr) minmax(150px, 1fr) minmax(150px, 1fr) minmax(200px, 1fr) minmax(100px, 1fr) minmax(200px, 1fr) minmax(200px, 1fr);
  background: #edf4ff;
  border-bottom: 1px solid #e4e7ed;
}

.order-header-cell {
  padding: 12px;
  color: rgb(140, 140, 140);
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

/* 每个订单项 */
.order-item {
  border-bottom: 1px solid #e4e7ed;
}

.order-item:last-child {
  border-bottom: none;
}

/* 订单基本信息行 */
.order-basic-row {
  display: grid;
  grid-template-columns: 1fr;
  background: #f7f8fc;
  border-bottom: 1px solid #e4e7ed;
}

.order-basic-info-cell {
  grid-column: 1 / -1;
  padding: 12px;
}

/* 订单详情行 */
.order-detail-row {
  display: grid;
  grid-template-columns: minmax(300px, 1fr) minmax(150px, 1fr) minmax(150px, 1fr) minmax(200px, 1fr) minmax(100px, 1fr) minmax(200px, 1fr) minmax(200px, 1fr);
  background: #fff;
  align-items: center;
}

.order-cell {
  padding: 12px;
  border-right: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 60px;
  text-align: left;
}

.order-cell:last-child {
  border-right: none;
}

.order-item:hover .order-detail-row {
  background-color: #f5f7fa;
}

/* 表格内容样式 */
.order-basic-info {
  /* padding: 8px 0; */
  font-size: 12px;
  color: #606266;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  background-color: transparent;
}

.order-number,
.create-time,
.order-status {
  margin-bottom: 0;
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}

.platform-order {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 0;
  white-space: nowrap;
}

.platform-order-link {
  color: #409EFF;
  font-size: 12px;
  margin-bottom: 4px;
  cursor: pointer;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.action-btn {
  width: 100%;
  margin: 0;
  padding: 4px 8px;
  font-size: 12px;
}

.product-detail {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 8px;
}

.product-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.product-text {
  flex: 1;
}

.platform-info {
  font-size: 12px;
  color: #409EFF;
  margin-bottom: 4px;
  font-weight: bold;
}

.product-name {
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
  line-height: 1.4;
  text-align: left;
}

.product-weight {
  font-size: 12px;
  color: #909399;
}

.express-info {
  padding: 12px 0;
}

.express-segment {
  margin-bottom: 4px;
  font-size: 12px;
}

.segment-label {
  color: #F56C6C;
  font-weight: bold;
}

.express-detail {
  color: #F56C6C;
}

.express-no {
  color: #303133;
  font-size: 14px;
}

.shipping-info {
  padding: 12px 0;
  font-size: 12px;
  line-height: 1.4;
}

.contact-info {
  color: #303133;
  margin-bottom: 4px;
  font-weight: 500;
}

.address {
  color: #909399;
}

.receive-info {
  padding: 12px 0;
  font-size: 12px;
  line-height: 1.4;
}

.platform-icon {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.platform-icon-img {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}

.platform-order {
  color: #409EFF;
  font-weight: bold;
}

.receiver-info {
  color: #303133;
  margin-bottom: 4px;
  font-weight: 500;
}

.receive-address {
  color: #909399;
}

.cost {
  color: rgb(228, 84, 84);
  font-weight: bold;
  font-size: 14px;
}

.express-number {
  padding: 12px 0;
  font-size: 12px;
}

.express-company {
  /* color: #409EFF; */
  margin-bottom: 4px;
  font-weight: 500;
}

.express-no {
  color: #303133;
  font-size: 14px;
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-top: 20px; */
  padding: 20px;
  background: #fff;
  /* border-top: 1px solid #e4e7ed; */
}

.pagination-info {
  color: #909399;
  font-size: 14px;
}

.pagination-component {
  text-align: center;
}

/* 自定义分页器样式 */
.custom-pagination {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-btn {
  padding: 4px 10px;
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.pagination-btn:hover:not(:disabled) {
  color: #409eff;
  border-color: #409eff;
}

.pagination-btn:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
  background-color: #f5f7fa;
}

.pagination-pages {
  display: flex;
  gap: 4px;
}

.pagination-page-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-page-btn:hover:not(:disabled):not(.active) {
  color: #409eff;
  border-color: #409eff;
}

.pagination-page-btn.active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

.pagination-page-btn.disabled {
  cursor: default;
  border: none;
  background: transparent;
}

/* 原有样式保留 */
.spanColors {
  font-weight: bold;
  border-top: rgb(221, 221, 221) 1px solid;
  border-right: rgb(221, 221, 221) 1px solid;
  border-left: rgb(221, 221, 221) 1px solid;
  border-bottom: white 2px solid;
  border-top-left-radius: 0.3em;
  border-top-right-radius: 0.3em;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}

.select_span {
  font-size: 14px;
  border: #dcdfe6 1px solid;
  border-radius: 4px;
  height: 32px;
  color: #606266;
  margin-left: 20px;
  margin-top: 5px;
  padding-bottom: 10px;
}

input {
  height: 30px;
  border: white solid 0px;
  border-radius: 0.4em;
}

input:focus {
  outline: none;
}

.borderless {
  box-shadow: none;
  height: 28px;
  width: 170px;
  margin-left: -5px;
}
</style>
<style>
.el-table .cell {
  padding: 0px;  
}
</style>



// WEBPACK FOOTER //
// src/views/syncOrder/orders/index.vue